import React from 'react';

function ShieldIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg width={width} height={height} {...props} viewBox="0 -960 960 960">
      <path d="M480-84q-7 0-13-1t-12-3q-135-45-215-166.5T160-516v-189q0-25 14.5-45t37.5-29l240-90q14-5 28-5t28 5l240 90q23 9 37.5 29t14.5 45v189q0 140-80 261.5T505-88q-6 2-12 3t-13 1Z" />
    </svg>
  );
}

export default ShieldIcon;
